<template>
  <div />
</template>
<script>
export default {
  name: "vue-network-checker",
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },
  mounted() {
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOfflineStatus);
  },
  created() {
    this.$mqtt.on("close", () => {
      this.$emit("mqtt_connection", false);
    });
    this.$mqtt.on("connect", () => {
      this.$emit("mqtt_connection", true);
    });
  },
  methods: {
    updateOnlineStatus(event) {
      this.$emit("wifi_status", true);
      this.$emit("wifi_event", event);
    },
    updateOfflineStatus(e) {
      this.$emit("wifi_status", false);
      this.$emit("wifi_event", event);
    },
  },
};
</script>